import React from "react";
import { string } from "prop-types";

import SavedStoryView from "../../rows/SavedStoryView";
import ProfileContainer from "../../rows/ProfileContainer";

const SavedPage = ({ currentPath }) => (
  <ProfileContainer type="saved_news" hideTopAd={true} currentPath={currentPath}>
    {({ member }) => <SavedStoryView member={member} currentPath={currentPath} />}
  </ProfileContainer>
);

SavedPage.propTypes = {
  currentPath: string,
};

export { SavedPage };
